module.exports = __webpack_public_path__ + "static/media/icon_check.1c35b0d0.svg";